import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ProductPackagesCountField from '@/components/analytics/product/ProductPackagesCountField.jsx';

export const CollectedField = ({ record }) => {
    const navigate = useNavigate();
    const handleClick = e => {
        e.stopPropagation();
        const filter = encodeURIComponent(JSON.stringify({ 'transactionContainers->product->id_in': [record.id] }));
        navigate(`/transaction?filter=${filter}`);
    };
    return (
        <Box sx={{ cursor: 'pointer' }} onClick={handleClick}>
            <ProductPackagesCountField record={record} />
        </Box>
    );
};
